import React from 'react';
import { useLocation } from 'react-router';
import { Movie } from 'src/@types/Movie';
import { galleryImagePageUrl, galleryImageUrl } from 'src/client/helpers/urls';
import Slider from 'src/client/components/sliders/Slider/Slider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTh } from '@fortawesome/pro-solid-svg-icons';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { ImageLink } from 'src/client/components/ui/ImageLink';

type Props = {
  relatedGallery: Movie['relatedGallery'];
  hasGalleryPermissions: boolean;
  siteUUID: string;
  contentCdnUrl: string;
  galleryPath: string;
  token?: string;
};

export const RelatedGalleries = (props: Props) => {
  const { hasGalleryPermissions, galleryPath, token } = props;
  const location = useLocation();
  const [joinUrl] = useJoinUrl({ campaign: 'movie-gallery' });

  if (!props?.relatedGallery?.media?.length) return null;

  const pathObject = { path: galleryPath };

  const tokenQs = token ? `?token=${token}` : '';

  const link = {
    pathname: hasGalleryPermissions
      ? `${galleryImagePageUrl(props.relatedGallery.media[0], pathObject).replace('/gallery', '/movie')}/grid${tokenQs}`
      : joinUrl,
    state: { prevPath: location.pathname },
  };

  const relatedGallery = {
    ...props.relatedGallery,
    media: props.relatedGallery.media.map((media) => ({
      ...media,
      url: hasGalleryPermissions
        ? `${galleryImagePageUrl(media, pathObject).replace('/gallery', '/movie')}${tokenQs}`
        : joinUrl,
      thumb: galleryImageUrl(media.galleryUUID, media.UUID, props.siteUUID, props.contentCdnUrl),
    })),
  };

  return (
    <Slider
      title="Movie Gallery"
      settings={relatedGallerySliderSettings}
      className="related-gallery"
      buttons={[
        <a href={link.pathname} key={link.pathname}>
          <FontAwesomeIcon icon={faTh} aria-hidden="true" className="slider-icon" />
        </a>,
      ]}
    >
      {relatedGallery.media.map((galleryItem) => (
        <ImageLink
          key={galleryItem.thumb}
          item={{
            imgSrc: galleryItem.thumb,
            url: galleryItem.url,
            displayOrder: galleryItem.displayOrder,
            altText: '',
          }}
          className="slider-img"
        />
      ))}
    </Slider>
  );
};

const relatedGallerySliderSettings = {
  autoplay: false,
  draggable: true,
  responsive: [
    { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    { breakpoint: 640, settings: { slidesToShow: 3, slidesToScroll: 3 } },
    { breakpoint: 986, settings: { slidesToShow: 4, slidesToScroll: 4 } },
    { breakpoint: 1200, settings: { slidesToShow: 6, slidesToScroll: 6 } },
    { breakpoint: 100000, settings: { slidesToShow: 8, slidesToScroll: 8 } },
  ],
};
